<template>
  <div class="bouncing-loader">
    <div></div>
  </div>
</template>

<script>
export default {
  name: "CertLoader"
}
</script>

<style lang="scss" scoped>
/* https://emilkowalski.github.io/css-effects-snippets/ */

$bounceSize: 13px;

.bouncing-loader > div,
.bouncing-loader:before,
.bouncing-loader:after {
  display: inline-block;
  width: $bounceSize;
  height: $bounceSize;
  background: $exBlue;
  margin-bottom: -5px;
  border-radius: 50%;
  animation: bouncing-loader 0.6s infinite alternate;
}

.bouncing-loader > div,
.bouncing-loader:before,
.bouncing-loader:after {
  content: "";
}

.bouncing-loader > div {
  margin: 0 5px;
}

.bouncing-loader > div {
  animation-delay: 0.2s;
}

.bouncing-loader:after {
  animation-delay: 0.4s;
}

@keyframes bouncing-loader {
  to {
    opacity: 0.1;
    transform: translate3d(0, -16px, 0);
  }
}
</style>